import {
  FilterV2Selection,
  flattenSelection,
} from "../../contexts/FilterContextV2";
import { IOptionProps } from "../../@types/reactSelect/IOption";
import { IFarm } from "../../@types/API/IFarm";

/** Primeira fazenda da seleção V2 (mesma fonte que FilterDataPolygonsV2 / mapa). */
export function firstFarmOptionFromV2Selection(
  selectedFarms: FilterV2Selection,
): IOptionProps | undefined {
  const first = flattenSelection(selectedFarms)[0];
  if (!first?.info) return undefined;
  const farm = first.info as IFarm;
  if (farm?.id === undefined || farm?.id === null) return undefined;
  return {
    label: first.label ?? String(farm.name ?? ""),
    value: farm.id,
    info: farm,
  };
}
